var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgU05 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.00 0.00 364.00 455.00",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(-1535.00, 0.00)",
    id: "U5_Copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1551.14,325.96 C1549.74,321.86 1543.44,285.25 1540.85,266.55 C1539.72,257.06 1538.94,239.06 1539.30,230.72 C1539.67,222.40 1541.96,206.65 1544.21,199.26 C1546.58,191.57 1553.15,177.72 1557.34,171.54 C1561.21,165.91 1571.90,154.42 1577.40,148.79 C1588.94,137.40 1608.03,120.30 1626.74,105.55 C1633.32,100.57 1646.87,90.52 1653.83,85.45 C1663.80,78.40 1675.28,71.00 1681.99,67.37 C1688.69,63.76 1701.37,58.38 1707.36,56.62 C1711.29,55.48 1717.07,54.37 1721.48,54.04 C1725.49,53.77 1733.17,54.13 1736.83,54.77 C1740.49,55.44 1747.46,57.70 1750.74,59.29 C1753.93,60.85 1769.77,71.34 1776.07,75.90 C1782.37,80.69 1792.02,88.46 1800.28,96.37 C1814.18,110.17 1873.43,176.57 1882.41,187.41 C1884.29,189.70 1887.56,195.84 1888.91,199.60 C1891.61,207.26 1894.05,223.56 1894.46,232.63 C1894.64,239.57 1894.49,254.76 1894.16,263.02 C1893.67,271.71 1892.19,290.39 1891.21,300.14 C1890.09,309.42 1887.47,326.53 1885.96,334.36 C1884.14,342.79 1880.32,356.49 1878.59,360.80 C1876.72,365.43 1872.25,373.83 1869.87,377.22 C1867.49,380.57 1862.32,385.84 1859.54,387.75 C1853.42,391.89 1789.52,415.87 1773.64,421.92 C1765.36,425.02 1749.85,429.38 1742.72,430.61 C1739.60,431.13 1732.26,431.97 1728.39,431.94 C1720.42,431.83 1706.44,429.09 1700.30,426.44 C1697.30,425.13 1680.41,416.36 1672.89,412.15 C1664.17,407.13 1631.74,385.32 1617.42,375.46 C1603.62,366.07 1569.67,344.85 1565.24,342.91 C1563.00,342.13 1558.89,340.48 1556.93,337.84 C1554.98,335.12 1551.81,327.90 1551.14,325.96 Z",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 10,
    strokeOpacity: 1,
    strokeLinejoin: "round"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgU05, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/U-05.debb3243.svg";
export { ForwardRef as ReactComponent };